import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    PublishLCTDevicePostResponse,
    TPublishLCTDeviceResponse,
} from "../../types/devices/lct/publishLctGeneralTypes"

type TPublishLCTDeviceMapper = {
    map: (response: unknown) => TPublishLCTDeviceResponse
}

export const publishLCTDeviceMapper: TPublishLCTDeviceMapper = {
    /** Maps the response returned from the POST publish LCT device endpoint to a ts-io derived type representing the result */
    map: (response: unknown): TPublishLCTDeviceResponse => {
        const mappedPostResponse = tsIoValidate(
            PublishLCTDevicePostResponse,
            response,
            "getPublishLCTDeviceMapper"
        )
        return {
            deviceRef: mappedPostResponse.SystemReference,
        }
    },
}
